
    var riot = require('riot')
    
riot.tag2('signup', '<div class="profile"> <form onsubmit="{handleSaveProfile}" class="form-horizontal"> <div hide="{hideform}" class="row"> <div class="col-md-6 col-xs-12"> <forminput name="title" label="Title*" onupdate="{handleUpdate}" value="{user.title}" placeholder="Mr / Mrs / Miss / Dr ...." isrequired=""></forminput> <forminput name="first_name" label="First Name*" onupdate="{handleUpdate}" value="{user.first_name}" isrequired=""></forminput> <forminput name="middlenames" label="Middlename(s)" onupdate="{handleUpdate}" value="{user.middlenames}"></forminput> <forminput name="surname" label="Surname*" onupdate="{handleUpdate}" value="{user.surname}" isrequired=""></forminput> <forminput name="occupation" label="Occupation" onupdate="{handleUpdate}" value="{user.occupation}"></forminput> <forminput name="email" label="Email*" onupdate="{handleUpdate}" value="{user.email}" isrequired=""></forminput> </div> <div class="col-md-6 col-xs-12"> <forminput name="org_name" label="Organisation" onupdate="{handleUpdate}" value="{user.org_name}" width1="3" width2="9" placeholder="Eg Hospital / Organisation"></forminput> <formtextarea name="address" label="Address" onupdate="{handleUpdate}" value="{user.address}" width1="3" width2="9" rows="3"></formtextarea> <forminput name="county" label="County" onupdate="{handleUpdate}" value="{user.county}" width1="3" width2="9"></forminput> <forminput name="postcode" label="Postcode" onupdate="{handleUpdate}" value="{user.postcode}" width1="3" width2="9"></forminput> <forminput name="country" label="Country" onupdate="{handleUpdate}" value="{user.country}" width1="3" width2="9"></forminput> <forminput name="phone1" label="Telephone" onupdate="{handleUpdate}" value="{user.phone1}" width1="3" width2="9"></forminput> <forminput name="phone2" label="Mobile*" onupdate="{handleUpdate}" value="{user.phone2}" width1="3" width2="9" isrequired=""></forminput> <div class="col-sm-9 col-sm-offset-3mydetails"> <div class="checkbox"> <label> <input type="checkbox" __checked="{gdpr}" onclick="{handleGDPR}">I agree for my information provided to be used inline with GDPR <a href="/contact-us/terms/">click here for more information</a><br> </label> </div> </div> <div class="row"> <div class="col-xs-9 col-xs-offset-3"> <button type="submit" __disabled="{!gdpr}" class="btn btn-primary">Sign Up</button> </div> </div> </div> </div> <div class="row"> <p><br></p> <div if="{message}" class="alert {\'alert-\'+status}">{message}</div> </div> </form> </div>', '', '', function(opts) {
var xhr;

xhr = require("../libs/xhr.coffee");

this.gdpr = false;

this.hideform = false;

this.on("mount", function() {
  this.user = {};
  if (window.location.search.match(/editmode=/)) {
    return this.root.innerHTML = "<div class='alert alert-info'>signup form</div>";
  }
});

this.handleUpdate = (function(_this) {
  return function(update) {
    _this.user[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleGDPR = (function(_this) {
  return function(e) {
    _this.gdpr = e.target.checked;
    return _this.update();
  };
})(this);

this.handleSaveProfile = (function(_this) {
  return function(e) {
    e.preventDefault();
    return xhr("POST", "/duocms/api/register", _this.user, function(res) {
      var status;
      status = res.status === 200 ? "success" : "danger";
      _this.update({
        message: res.body.message || res.body.data.message,
        status: status
      });
      if (status === "danger") {
        setTimeout((function() {
          return _this.update({
            message: false
          });
        }), 4000);
      }
      if (status === "success") {
        _this.hideform = true;
        return _this.update();
      }
    });
  };
})(this);
});
    
  